// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M21,12c0,5-4,9-9,9s-9-4-9-9s4-9,9-9c2.4,0,4.7,0.9,6.4,2.6C18.8,6,19.2,6.5,19.5,7h-4v1H21V2.5h-1V6
		c-0.3-0.4-0.6-0.7-0.9-1.1C15.2,1,8.8,1,4.9,4.9S1,15.2,4.9,19.1s10.2,3.9,14.1,0c1.9-1.9,2.9-4.4,2.9-7.1H21z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-refresh-CB-7YV0I.js.map
